import { StatusBar } from "expo-status-bar";
import React, { useState, useEffect } from "react";
import { Video } from "expo-av";
import axios from "axios";
import {
  StyleSheet,
  Text,
  SafeAreaView,
  ImageBackground,
  Image,
  TouchableOpacity,
  Linking,
} from "react-native";
import { Icon } from "react-native-elements";

export default function App() {
  const [output, setOutput] = useState(0);
  const [textOutput, setTextOutput] = useState(0);
  const [imageOutput, setImageOutput] = useState(0);
  const [videoOutput, setVideoOutput] = useState(0);
  const [linkOutput, setLinkOutput] = useState(0);
  const [linkImageOutput, setLinkImageOutput] = useState(0);
  useEffect(() => {
    let RandomNumber = Math.floor(Math.random() * 100) + 1;
    if (RandomNumber % 2 == 0) {
      setOutput("image");
      axios
        .get(`https://somethings.life/api/v1/client/getimage`)
        .then((response) => {
          setImageOutput({ events: response.data });
        })
        .catch((err) => console.log(err));
    } else if (RandomNumber % 3 == 0) {
      setOutput("link");
      axios
        .get(`https://somethings.life/api/v1/client/GetLink`)
        .then((response) => {
          setLinkImageOutput({ events: response.data.Image });
          setLinkOutput({ events: response.data.Link });
        })
        .catch((err) => console.log(err));
    } else if (RandomNumber % 5 == 0) {
      setOutput("video");
      axios
        .get(`https://somethings.life/api/v1/client/GetVideo`)
        .then((response) => {
          setVideoOutput({ events: response.data });
        })
        .catch((err) => console.log(err));
    } else {
      setOutput("text");
      axios
        .get(`https://somethings.life/api/v1/client/GetText`)
        .then((response) => {
          setTextOutput({ events: response.data });
        })
        .catch((err) => console.log(err));
    }
  }, []);
  return (
    <SafeAreaView style={styles.container}>
      {output == "image" ? (
        <Image
          style={styles.image}
          source={{
            uri: imageOutput.events,
          }}
        />
      ) : null}
      {output == "text" ? <Text>{textOutput.events}</Text> : null}
      {output == "video" ? (
        <Video
          source={{ uri: videoOutput.events }}
          rate={1.0}
          volume={1.0}
          isMuted={false}
          resizeMode="cover"
          shouldPlay
          isLooping
          style={{ width: "100%", height: "100%" }}
        />
      ) : null}
      {output == "link" ? (
        <ImageBackground
          style={styles.imageLink}
          source={{
            uri: linkImageOutput.events,
          }}
        >
          <TouchableOpacity
            onPress={() => {
              Linking.openURL(linkOutput.events);
            }}
            style={styles.roundButton}
          >
            <Icon name={"link"} size={60} color="#FFFFFF" />
          </TouchableOpacity>
        </ImageBackground>
      ) : null}
      <StatusBar style="auto" />
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
  image: {
    flex: 1,
    height: "auto",
    width: "100%",
    resizeMode: "stretch",
    justifyContent: "center",
  },
  imageLink: {
    top: "10%",
    width: "95%",
    height: "70%",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    left: "2.5%",
  },
  roundButton: {
    width: 80,
    height: 80,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 100,
    backgroundColor: "red",
    position: "absolute",
    bottom: "13%",
    left: "38%", //(100-width)/2
    transform: [{ rotate: "145deg" }],
  },
});
